export const habaAddress = {
  habaAddressForm: {
    invoiceCustomerCustomEmailLabel: 'Abweichende E-Mail-Adresse',
    customerBenefitsTitle: 'Vorteile Ihres Benutzerkontos',
    customerBenefitsEmailItem: 'Bezahlen per Rechnung',
    customerBenefitsMapPinItem: 'Verwaltung verschiedener Liefer- und Rechnungsadressen',
    customerBenefitsDeliveryTruckItem: 'Lieferstatus und Ihre gesamte Bestellhistorie im Überblick',
    customerBenefitsDeliveryInfoItem: 'Unverbindliche individuelle Vorabangebote anfordern',
    customerBenefitsDeliveryHeartItem: 'Erstellung von mehreren Merklisten',
    warningBannerTitle: 'Achtung',
    warningBannerMsg: {
      private: 'Bitte geben Sie Ihre Kundennummer an, falls vorhanden (z.B. aus vorherigen Aufträgen).',
      institution: "Bitte geben Sie die offizielle Bezeichnung Ihrer Einrichtung an, und Ihre Kundennummer falls vorhanden. (z.B. aus vorherigen Aufträgen)",
      carrier: "Bitte geben Sie die offizielle Bezeichnung des Trägers an, und Ihre Kundennummer falls vorhanden. (z.B. aus vorherigen Aufträgen)",
      association: "Bitte geben Sie die offizielle Bezeichnung Ihres Vereins an, und Ihre Kundennummer falls vorhanden. (z.B. aus vorherigen Aufträgen)",
      company: "Bitte geben Sie die offizielle Bezeichnung Ihres Unternehmens an, und Ihre Kundennummer falls vorhanden. (z.B. aus vorherigen Aufträgen)",


    },

    defaultEmployeeInfoSectionAddressTitle: 'Ihre Daten als Kunde',
    institutionEmployeeInfoSectionAddressTitle: 'Ihre Daten als Mitarbeiter der Einrichtung',
    carrierEmployeeInfoSectionAddressTitle: 'Ihre Daten als Mitarbeiter des Trägers',
    carrierEmployeeInfoSectionAddressSubTitle: 'Das sind Ihre Anmeldedaten. Sie sind Ansprechpartner für Bestellungen dieses Benutzerkontos',
    associationEmployeeInfoSectionAddressTitle: 'Ihre Daten als Mitglied des Vereins',
    companyEmployeeInfoSectionAddressTitle: 'Ihre Daten als Mitarbeiter des Unternehmens',
    privateEmployeeInfoSectionAddressTitle: 'Ihre Daten als Privatkunde',
    defaultOrganizationDetailsSectionAddressTitle: 'Details Ihrer Einrichtung',
    defaultOrganizationDetailsSectionAddressSubtitle: 'nennen Sie uns bitte die Daten für Ihre Rechnung.',
    organizationDetailsSectionAddressInfo: {
      DE: 'Bestellungen sind ausschließlich in Deutschland zugelassen.',
      AT: 'Bestellungen sind ausschließlich in Österreich zugelassen.',
    },
    deviatingDeliveryAddressInfo: {
      DE: 'Rechnungsempfänger sind ausschließlich in Deutschland zugelassen.',
      AT: 'Rechnungsempfänger sind ausschließlich in Österreich zugelassen.',
    },
    institutionOrganizationDetailsSectionAddressTitle: 'Details Ihrer Einrichtung',
    carrierOrganizationDetailsSectionAddressTitle: 'Details des Trägers',
    associationOrganizationDetailsSectionAddressTitle: 'Details Ihres Vereins',
    companyOrganizationDetailsSectionAddressTitle: 'Details des Unternehmens',
    privateOrganizationDetailsSectionAddressTitle: 'Rechnungsdetails',
    deliverySectionAddressTitle: 'Lieferung',
    invoiceSectionAddressTitle: 'Rechnung',
    invoiceSectionAddressSubtitle: 'Benötigen Sie einen angepassten Rechnungsversand oder Rechnungsempfänger, bezahlt z.B. Ihr Träger die Rechnung?',
    deliveryFormAddressTitle: 'Wohin soll die Lieferung erfolgen?',
    deliveryFormNewAddressRadioLabel: 'Abweichende Lieferadresse',
    deliveryFormNewAddressInfo: {
      DE: 'Lieferungen sind ausschließlich nach Deutschland möglich.',
      AT: 'Lieferungen sind ausschließlich nach Österreich möglich.',
    },
    billingFormNewAddressInfo:{
      DE: 'Rechnungsempfänger sind ausschließlich in Deutschland zugelassen.',
      AT: 'Rechnungsempfänger sind ausschließlich in Österreich zugelassen.',
    }
    ,
    deliveryFormPhoneDataTitle: 'Wer ist der Ansprechpartner für diese Lieferung?',
    deliveryFormPhoneDataSubTitle: 'Im Falle einer Speditionslieferung kontaktieren wir diesen Ansprechpartner vor der Lieferung.',
    deliveryFormPhoneDataRegistrationTitle: 'Wer ist Ansprechpartner für Lieferungen?',
    deliveryFormNewPhoneDataRadioLabel: 'Abweichender Ansprechpartner',
    deliverAndInvoiceClosedSectionAddressTitle: 'Rechnung und Lieferung',
    customerTypeSectionAddressTitle: 'Art Ihres Benutzerkontos',
    customerTypeSectionAddressSubTitle:
      'Bitte geben Sie an, ob Sie sich für eine Organisation oder privat registrieren',
    clientPersonTitle: 'Sie sind Ansprechpartner für diese Bestellung.',
    shippingTitle: 'Welcher Adresse soll die Lieferung erfolgen?',
    emailTitle: ' Wir senden die Rechnung ausschließlich an die hier angegebene E-Mail-Adresse.',
    billingTitle: "Welcher Rechnungsempfänger soll auf der Rechnung stehen?",
    deviatingAddressLabel: 'Abweichender Rechnungsempfänger',
    deviatingEmail: {
      title: "An welche E-Mail-Adresse soll die Rechnung versendet werden?",
      subtitle: "Wir senden die Rechnung ausschließlich an die hier angegebene E-Mail-Adresse."
    },
    deviatingAddress: {
      title: "Wer soll als Rechnungsempfänger auf der Rechnung stehen (Warenempfänger steht ebenfalls im Rechnungskopf)?",
    },
    gtcHtml: 'Ich erkenne die <span style="text-decoration: underline;">Datenschutzerklärung</span> sowie die <span style="text-decoration: underline;">AGBs</span> von WEHRFRITZ an. Sie haben per Gesetz ein 14-tägiges Widerrufsrecht. Einzelheiten und Ausnahmen dazu in unserer Widerrufsbelehrung.',
    newsletter: 'Ich möchte mich für den WEHRFRITZ Newsletter anmelden.',
    nextLabel: 'Als nächstes',
    requiredLabel: 'Pflichtfeld',
    heading: 'Lieferadresse',
    backWithoutChanges: 'Zurück ohne Änderung',
    customerType: {
      institution: 'Einrichtung (z.B. Kindergarten, Krippe, Schule)',
      carrier: 'Träger (z.B. Gemeinde, Sozialverband)',
      association: 'Verein (z.B. Förderverein, Sportverein)',
      company:
        'Unternehmen (z.B. Praxen / Gesundheitseinrichtungen, Architekten, Garten- und Landschaftsbauer)',
      private: 'Privatkunde',
    },
    section: {
      billingAddress: 'Rechnungsadresse',
      billingAddressQuestion: 'Wie lautet Ihre Adresse',
      billingAddressEdit: 'Rechnungsadresse bearbeiten',
      billingAddressNew: 'Rechnungsadresse hinzufügen',
      shippingAddress: 'Lieferadresse',
      shippingAddressEdit: 'Lieferadresse bearbeiten',
      shippingAddressNew: 'Lieferadresse hinzufügen',
      shippingAdressUpdate: 'Diese Adresse verwenden',
      shippingAdressNext: 'Weiter',
    },
    personalData: 'Wie lauten deine persönlichen Daten?',
    form: {
      error: {
        streetNameOnAdditional: "Der wurde Straßenname sowohl im Feld „Straße“ als auch im Feld „Adresszusatz“ eingetragen. Um eine korrekte Zustellung sicherzustellen, verwenden Sie das Feld „Adresszusatz“ bitte nur für zusätzliche Angaben (z. B. Gebäudeteil, Etage, Raum, z. Hd.).",
        streetNrOnStreetName: "Es scheint, dass die Browser-Adressvervollständigung einige Felder automatisch ausgefüllt hat. Bitte stellen Sie sicher, dass im Feld „Straße“ nur der Straßenname (ohne Hausnummer) eingetragen ist.",
        postalCodeOnTown: "Es scheint, dass die Postleitzahl sowohl im Feld „Postleitzahl“ als auch im Feld „Ort“ eingetragen wurde. Bitte geben Sie im Feld „Ort“ ausschließlich den Ortsnamen ein, um Verzögerungen in der Bearbeitung zu vermeiden.",
        duplicateCompanyName: "Sie haben den Firmennamen zweimal eingegeben. Bitte entfernen Sie doppelten Text. Wenn Ihr Firmenname in die erste Zeile passt, können Sie das zweite Namensfeld leer lassen.",
      },
      client: 'Auftraggeber*',
      clientSecondLine: "Auftraggeber - 2.Zeile",
      yourBillingAddress: 'Ihre Rechnungsadresse{*}',
      contact: 'Ansprechpartner der Firma / Einrichtung',
      addressType: {
        private: 'Privatperson',
        firm: 'Firma',
        institution: 'Einrichtung',
        firmInstitution: 'Einrichtung/Firma',
      },
      privateCompanyToggle: {
        private: 'Privatkunde',
        company: 'Firmenkunde',
      },
      title: {
        label: 'Anrede',
        error: 'Bitte Anrede auswählen',
      },
      firstName: {
        label: 'Vorname*',
        error: 'Bitte Vorname eingeben',
      },
      lastName: {
        label: 'Nachname*',
        error: 'Bitte Nachname eingeben',
      },
      dateOfBirth: {
        label: 'Geburtstag',
        invalidDate:
          'Bitte überprüfen Sie Ihr Geburtsdatum. Das erforderliche Mindestalter ist nicht erreicht.',
      },
      companyName: {
        label: 'Firmenname*',
        error: 'Bitte Firma eingeben',
      },
      companyNameExtension: {
        label: 'Firmenname Erweiterung',
      },
      unverifiedCustomerId: {
        label: 'Kundennummer unbestätigt',
      },
      alreadyCustomer: {
        label: 'Bereits Kunde bei Wehrfritz, aber noch kein Konto im Onlineshop vorhanden',
      },
      firmInstitutionName: {
        label: 'Einrichtung/Firma',
        error: 'Bitte Einrichtung/Firma eingeben',
      },
      vatID: {
        label: 'Umsatzsteuer-Identifikationsnr.',
        error: 'Bitte UST-ID eingeben',
      },
      institution: {
        label: 'Einrichtung',
      },
      street: {
        label: 'Straße*',
        error: 'Bitte Straße eingeben',
      },
      streetNumber: {
        label: 'Nr.*',
        error: 'Bitte Hausnummer eingeben',
      },
      additionalAddressInfo: {
        label: 'Adresszusatz',
      },
      country: {
        label: 'Land*',
        error: 'Bitte Land auswählen',
      },
      city: {
        label: 'Ort*',
        error: 'Bitte Ort eingeben',
      },
      zipCode: {
        label: 'PLZ*',
        error: 'Die Postleitzahl muss {{length}} Stellen lang sein.',
      },
      industry: {
        label: 'Branche*',
        error: 'Pflichtfeld: Bitte wählen Sie die Branche',
      },
      email: {
        label: 'E-Mail-Adresse*',
      },
      password: {
        label: 'Passwort für Ihr Benutzerkonto',
      },
      salutation: {
        label: 'Anrede',
        sir: 'Herr',
        madam: 'Frau',
        none: 'keine Angabe',
        error: 'Bitte Anrede auswählen',
      },
      phone: {
        prefix: 'Ländervorwahl',
        label: 'Telefonnummer',
        label2: 'Telefonnummer - z.B. für Fragen zur Bestellung',
        labelMobile: 'Telefonnummer*',
        error:
          'Bitte geben Sie eine gültige Telefonnummer ein (7–20 Zeichen, nur Ziffern und + - / , ( ) sind erlaubt).',
        message: '(für eventuelle Rückfragen bei der Lieferung)*',
      },
      birthDate: {
        label: 'Geburtstag',
      },
      year: {
        label: 'Jahr*',
        error: 'Bitte Jahr eingeben',
      },
      month: {
        label: 'Monat*',
        error: 'Bitte Monat eingeben',
      },
      day: {
        label: 'Tag*',
        error: 'Bitte Tag eingeben',
      },
      defaultDeliveryAddress: 'Als meine Standard Lieferadresse festlegen',
      optional: '(optional)',
      useAsDeliveryAddress: 'Die Lieferung soll an oben stehende Adresse erfolgen',
      labels: {
        institution: {
          name1: "Name der Einrichtung*",
          name2: "Name der Einrichtung - 2.Zeile",
        },
        carrier: {
          name1: "Name des Trägers*",
          name2: "Name des Trägers - 2.Zeile",
        },
        association: {
          name1: "Name des Vereins*",
          name2: "Name des Vereins - 2.Zeile",
        },
        company: {
          name1: "Name des Unternehmens*",
          name2: "Name des Unternehmens - 2.Zeile",
        },
        generic: {
          name1: "Warenempfänger*",
          name2: "Warenempfänger 2. Zeile",
        },
        deviating: {
          name1: "Rechnungsempfänger*",
          name2: "Rechnungsempfänger 2. Zeile",
        }
      }
    },
    continueAsGuest: "Als Gast bestellen (keine Zahlung per Rechnung möglich)",
    billingAddress: {
      selectAddress: 'Wähle die mit deiner Karte oder Zahlungsmethode verknüpfte Adresse aus.',
      sameWithShippingAddress: 'Mit der Lieferadresse identisch',
    },
    correctionDialog: {
      title: 'Adresse bestätigen',
      subtitle: 'Wir haben eine mögliche Abweichung erkannt. Bitte prüfen Sie kurz die empfohlene Adresse.',
      yourInput: 'Ihre Eingabe',
      recommendedAddress: 'Empfohlene Adresse',
      acceptBtn: 'Eingabe behalten'
    },
  },
  habaAddressMelissa: {
    heading: 'Adressprüfung',
    paragraph:
      'Lieber Kunde, leider ist uns deine Adresse nicht bekannt. Bitte überprüfe diese Adressvorschläge und bestätige deine Adresse',
    suggestions: 'Meinten Sie vielleicht:',
    yourInput: 'Deine Eingabe:',
    submitButton: 'AUSWAHL ÜBERNEHMEN & WEITER',
  },

};
